import React from "react";
import Layout           from 'layouts/BasicLayout.jsx';


class Home extends React.Component{
    render(){
        return (
            <Layout>
                <h2>Home</h2>
            </Layout>
        )
    }
}

export default Home